import React from "react";
import Section from "../Section/Section";
import Link from "../Link/Link";
import styles from "./PaymentTermsAndConditions.module.less";
import { defineMessages, FormattedMessage } from "react-intl";
import longMessage from "../../../../../../../macros/longMessage.macro";
const messages = defineMessages({
    onlinePaymentAgreement: {
        id: "paymentTerms.onlinePaymentAgreement.header",
        defaultMessage: "Online Payment Agreement (“Agreement”)"
    },
    usingOnlinePayments: {
        id: "paymentTerms.usingOnlinePayments.header",
        defaultMessage: "Using Online Payments."
    },
    unauthorizedTransfersErrorsOrQuestions: {
        id: "paymentTerms.unauthorizedTransfersErrorsOrQuestions.header",
        defaultMessage: "Unauthorized Transfers, Errors or Questions."
    },
    liabilityForTransfers: {
        id: "paymentTerms.specialtyLive.liabilityForTransfers.header",
        defaultMessage: "Liability for Transfers."
    },
    terminationChangesInsufficientFunds: {
        id: "paymentTerms.specialtyLive.terminationChangesInsufficientFunds.header",
        defaultMessage: "Termination, Changes, Insufficient Funds."
    }
});
const Strong = ({ children }) => (<strong className={styles.strong}>{children}</strong>);
class SpecialtyLivePaymentTermsAndConditions extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            readAgreement: false
        };
        this._handleAgreementScroll = this._handleAgreementScroll.bind(this);
    }
    _handleAgreementScroll() {
        if (this.state.readAgreement || this._agreementElement == null) {
            return;
        }
        if (this._agreementElement.scrollHeight - this._agreementElement.scrollTop - this._agreementElement.parentElement.clientHeight <= 3) {
            this.setState({ readAgreement: true });
            this.props.onReadAgreement();
        }
    }
    componentDidMount() {
        this._handleAgreementScroll();
    }
    componentDidUpdate() {
        this._handleAgreementScroll();
    }
    render() {
        return (<div className={styles.paymentTAndC} ref={it => this._agreementElement = it} onScroll={this.state.readAgreement ? undefined : this._handleAgreementScroll}>
				<div>
					<div className="vr vr_x4">
						<h2 className={styles.heading}>
							<FormattedMessage id="paymentTerms.header" defaultMessage="DCMS ServiceLink® Terms and Conditions"/>
						</h2>
					</div>

					<Section title={messages.onlinePaymentAgreement}>
						<FormattedMessage tagName="p" id="paymentTerms.specialtyLive.onlinePaymentAgreement.1" defaultMessage={longMessage `
								By utilizing the DCMS ServiceLink® payment option (“Online Payments”) you authorize DCM Services
								(“DCMS”) to initiate a one-time electronic funds transfer (“Transfer”) from your checking or savings
								account (“Funding Account”), using the information you provide to DCMS for the purpose of making a
								payment on the date (“Payment Date”) and in the amount you specify.
							`}/>

						<FormattedMessage tagName="p" id="paymentTerms.specialtyLive.onlinePaymentAgreement.2" defaultMessage={longMessage `
								In order to utilize Online Payments, you must read and agree to this Agreement. This Agreement is in
								addition to our Privacy Policy ({link1}) and Website Terms of Use ({link2}), which also apply to you.
								In its sole discretion, DCMS may amend or change this Agreement from time to time.
							`} values={{
            link1: <Link href="https://www.dcmservices.com/privacy-policy"/>,
            link2: <Link href="https://www.dcmservices.com/terms-of-use"/>
        }}/>
					</Section>

					<Section title={messages.usingOnlinePayments}>
						<p>
							<FormattedMessage id="paymentTerms.specialtyLive.usingOnlinePayments.1" defaultMessage={longMessage `
									Once you submit an Online Payment, it is final and cannot be canceled or modified through this platform.
									If you need to cancel this payment for any reason, you must contact the financial institution that holds
									your Funding Account, directly.
								`}/>
						</p>
					</Section>

					<Section title={messages.unauthorizedTransfersErrorsOrQuestions}>
						<p>
							<FormattedMessage id="paymentTerms.specialtyLive.unauthorizedTransfersErrorsOrQuestions.1" defaultMessage={longMessage `
									In case of errors or questions about Transfers made via Online Payments or if you suspect a Transfer has
									been or may be made without your permission, contact DCMS immediately in writing at {address}, or by phone
									at {phone}. You should also contact the financial institution that holds your Funding Account.
								`} values={{
            address: (<Strong>
											<FormattedMessage id="paymentTerms.unauthorizedTransfersErrorsOrQuestions.1.address" defaultMessage="DCM Services, LLC, 1550 American Blvd E., Suite 200, Bloomington, MN 55425"/>
										</Strong>),
            phone: (<Strong>
											<FormattedMessage id="paymentTerms.unauthorizedTransfersErrorsOrQuestions.1.phone" defaultMessage="1-877-326-8786"/>
										</Strong>)
        }}/>
							{" "}
							<Strong>
								<FormattedMessage id="paymentTerms.specialtyLive.unauthorizedTransfersErrorsOrQuestions.2" defaultMessage={longMessage `
										You are solely responsible for monitoring your Funding Account to verify that Transfers have been
										processed and to identify any issues related to Transfers.
									`}/>
							</Strong>
						</p>
					</Section>

					<Section title={messages.liabilityForTransfers}>
						<p>
							<FormattedMessage id="paymentTerms.specialtyLive.liabilityForTransfers.1" defaultMessage={longMessage `
									DCMS is not liable for any loss or damage you may incur if: (1) you do not have enough money in your
									Funding Account to make a Transfer; (2) circumstances beyond DCMS control, including but not limited to,
									natural disaster, flood, earthquake, fire, war, act of terrorism, or acts of third parties in violation
									of federal, state, or international law, render DCMS unable to effectuate the Transfer despite
									reasonable precautions under the circumstances; (3) you provide incorrect Funding Account information to
									authorize a Transfer; or (4) the financial institution that holds your Funding Account fails to
									effectuate a Transfer, causes errors during a Transfer, or provides DCMS erroneous information.
								`}/>
							{" "}
							<Strong>
								<FormattedMessage id="paymentTerms.specialtyLive.liabilityForTransfers.2" defaultMessage={longMessage `
										DCMS IS NOT RESPONSIBLE OR LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, CONSEQUENTIAL, SPECIAL,
										EXEMPLARY, PUNITIVE, OR OTHER DAMAGE RELATED TO YOUR USE OF ONLINE PAYMENTS.
									`}/>
							</Strong>
						</p>
					</Section>

					<Section title={messages.terminationChangesInsufficientFunds}>
						<FormattedMessage id="paymentTerms.specialtyLive.terminationChangesInsufficientFunds" defaultMessage={longMessage `
								DCMS is under no obligation to provide Online Payments and may in its sole discretion and at any time
								without notice, modify, revoke access to or no longer offer Online Payments. It is your responsibility to
								ensure that you have sufficient funds to cover each Transfer. DCMS also has the option in its sole
								discretion to terminate your access to Online Payments if any Transfer is returned or reversed due to
								non-sufficient or insufficient funds, cancellation, stop-payment or any similar designation.
							`}/>
					</Section>
				</div>
			</div>);
    }
}
export default SpecialtyLivePaymentTermsAndConditions;



// WEBPACK FOOTER //
// ./src/assets/scripts/components/containers/public/legal/PaymentTermsAndConditions/SpecialtyLivePaymentTermsAndConditions.tsx